import { render } from "./Prestador_ElemPres.vue?vue&type=template&id=aa9af162&scoped=true"
import script from "./Prestador_ElemPres.vue?vue&type=script&lang=js"
export * from "./Prestador_ElemPres.vue?vue&type=script&lang=js"

import "./Prestador_ElemPres.vue?vue&type=style&index=0&id=aa9af162&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9af162"]])

export default __exports__